export default __webpack_public_path__ + "static/media/1196.e6674a4f.jpg";